import { clearKitRegistrationReturnKitId } from '@/utilities/auth/kitRegistrationReturnKitId'
import { clearSampleCollectionReturnKitId } from '@/utilities/auth/sampleCollectionReturnKitId'

/** Clears kit ids saved for post-login flow resume. Safe on Client Portal logout. */
export function clearPatientSessionResumeKitIds(): void {
  clearKitRegistrationReturnKitId()
  clearSampleCollectionReturnKitId()
}
